import React, { useMemo, useCallback, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Edit } from '@material-ui/icons';
import { includes, isArray } from 'lodash';

import api from '~/services/api';
import { t } from '~/helpers';
import { UnidataTable, Modal } from '~/components';
import {
  deleteUnidade,
  findUnidade,
  recordFiltering,
} from '~/store/modules/unidade/actions';
import { resetValues } from '~/store/modules/unityRegistration/actions';
import { ADM, GFO, GFU, GFE } from '~/constants/perfil';

import FormUnidade from './FormUnidade';

export default function UnidadeList() {
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const data = useSelector((state) => state.unidade);
  const { glousuariotipo, gloperfilid } = useSelector(
    (state) => state.user.profile
  );



  const optionsSN = useMemo(
    () => [
      { label: 'SIM', value: 'Sim' },
      { label: 'NAO', value: 'Não' },
    ],
    []
  );

  const optionsAI = useMemo(
    () => [
      { label: 'Ativa', value: 'Ativa' },
      { label: 'Inativa', value: 'Inativa' },
    ],
    []
  );

  const header = useMemo(
    () => [
      { id: 'orga_nome', label: 'Nome do Órgão', filter: { type: 'text' } },
      { id: 'unid_codigo', label: 'Código', filter: { type: 'text' } },
      { id: 'unid_nome', label: 'Nome da Unidade', filter: { type: 'text' } },
      {
        id: 'unid_status_str',
        label: 'Status',
        formatted: (value) => optionsAI.find((s) => s.label === value).value,
        filter: { type: 'select', options: optionsAI },
      },
      glousuariotipo === ADM
        ? {
          id: 'unid_bloqueio_inadimplencia_str',
          label: 'Status Inadimplência',
          formatted: (value) =>
            optionsSN.find((s) => s.label === value).value,
          filter: { type: 'select', options: optionsSN },
        }
        : {},
    ],
    [optionsSN, optionsAI, glousuariotipo, ADM]
  );

  const handleGetAPIUnity = useCallback(async (id, organ) => {
    try {
      await api.get(`unidades/pesquisaunidade/${id}/${organ}`).then(({ data }) => {
        modalRef.current.handleOpenModal({
          data: data.unidade,
          diasLiberacao: data.diasLiberacao,
          datasBloqueio: data.datasBloqueio,
          municipios: data.municipios,
          municipioprodutos: data.municipioprodutos,
          cotas: data.cotas,
        });
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data.params]);

  const buttons = useMemo(() => {
    if (includes([ADM, GFO, GFU, GFE], gloperfilid)) {
      return [
        {
          title: 'Alterar',
          action: (value) =>
            handleGetAPIUnity(value.unid_codigo, value.orga_codigo),
          icon: <Edit />,
        },
      ];
    }

    return [];
  }, [gloperfilid, data.params]);

  const handleAfterClosingModal = () => {
    dispatch(recordFiltering(data.params));
    dispatch(resetValues());
  };


  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="unid_nome ASC"
        fixed
        header={header}
        redux={data}
        actions={buttons}
        read={recordFiltering}
        remove={deleteUnidade}
        find={findUnidade}
        create={false}
        update={false}
        detach="unid_nome"
        keys="unid_codigo"
        view="VW_UNIDADE"
        reportTitle="Cadastro de Unidade"
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title="Cadastro de Unidade"
        maxWidth="md"
        fullScreen={window.innerWidth <= 425}
        component={FormUnidade}
        onClose={handleAfterClosingModal}
      />
    </>
  );
}
